<template>
    <div class="FieldPackage">
        <label class="FieldPackageItem" v-for="p of packages.fields" :class="{'is-selected': p.id === packages.selected}">
            <input type="radio" :value="p.id" v-model="packages.selected">
            <span class="FieldPackageItem-name">{{p.name}}</span>
            <span class="FieldPackageItem-perex">{{p.perex}}</span>
            <span class="FieldPackageItem-discount" v-if="p.percentage">-{{p.percentage}}%</span>
            <PackageIcon class="FieldPackageItem-icon" :packageId="p.id" anchor="top"></PackageIcon>
        </label>
    </div>
</template>

<script>
import PackageIcon from '../PackageIcon.vue'

export default {
    components: {PackageIcon},
    props: {
        packages: Object
    }
}
</script>

<style lang="scss">
    .FieldPackage {
        display: flex;
        flex-wrap:wrap;
        margin: 0 -.5%;
    }
    .FieldPackageItem {
        width: 32.333%;
        margin: .5%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        cursor: pointer;
        border: 2px solid var(--colorInputBorder);
        position: relative;
        padding: 2em;
        overflow: hidden;
		transition: all .25s ease-in-out;
        @media(max-width: 550px) {
            width: 99%;
        }

		&:hover {
			border-color: var(--colorBrand);
		}

        &.is-selected {
			border-color: var(--colorBrand);
			background: var(--colorBrandLighten);
        }

        &-name {
            text-align: center;
            font-weight: 700;
            font-size: var(--textMd);
            margin-bottom: 1em;
            color: var(--colorBrandDark);
        }

        &-perex {
			margin-bottom: auto;
        }

        &-icon {
            display: flex;
            margin-top: 1.1em;
        }

        &-discount {
            position: absolute;
            top: .7em;
            right: -1em;
            background: var(--colorBrand);
            color: #fff;
            padding: .1em .9em;
            text-align: center;
            transform: rotate(45deg);
            transform-origin: bottom center;
            width: 7em;
            font-weight: 700;
        }

        input {
            margin-bottom: 10px;
            display: none;
        }
    }
</style>